import { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import SessionsCarousel from "../../../../../../../components/sharedComponents/SessionsCarousel";
import { InputTextarea } from "primereact/inputtextarea";
import { Divider } from "primereact/divider";
import AllTaskQuestionViewComponent from "../AllTaskQuestionViewComponent/AllTaskQuestionViewComponent";

const PhotoOnlyXmotType = () => {
  const [selectedSession, setSelectedSession] = useState(0);
  const [showPlayerFullView, setShowPlayerFullView] = useState(false);
  const scrollContainerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const [allTQToggle, setAllTQToggle] = useState(false);

  const sessions = [
    { id: 1, name: "Wendoline S", title: "Cooking In Your Home" },
    { id: 2, name: "Alex Q", title: "Cooking In Your Home" },
    { id: 3, name: "Ira D", title: "Cooking In Your Home" },
    { id: 4, name: "Jesseca A", title: "Cooking In Your Home" },
    { id: 5, name: "Jeff B", title: "Cooking In Your Home" },
    { id: 6, name: "Kimberlee C", title: "Cooking In Your Home" },
    { id: 7, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 8, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 9, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 10, name: "Bobby S", title: "Cooking In Your Home" },
  ];

  const slides = [
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://examples.ucarecd.net/8933b9bc-2e8b-46fd-9aca-afb8353d8f8c/-/scale_crop/1332x1034/",
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://examples.ucarecd.net/8933b9bc-2e8b-46fd-9aca-afb8353d8f8c/-/scale_crop/1332x1034/",
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://examples.ucarecd.net/8933b9bc-2e8b-46fd-9aca-afb8353d8f8c/-/scale_crop/1332x1034/",
  ];

  const thumbs = [
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://examples.ucarecd.net/8933b9bc-2e8b-46fd-9aca-afb8353d8f8c/-/scale_crop/1332x1034/",
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://examples.ucarecd.net/8933b9bc-2e8b-46fd-9aca-afb8353d8f8c/-/scale_crop/1332x1034/",
    "https://ucarecdn.com/05f649bf-b70b-4cf8-90f7-2588ce404a08/-/quality/lightest/",
    "https://examples.ucarecd.net/8933b9bc-2e8b-46fd-9aca-afb8353d8f8c/-/scale_crop/1332x1034/",
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const intervalRef = useRef(null);

  // Autoplay Logic
  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setActiveIndex((prev) => {
          if (prev === slides.length - 1) {
            // Stop autoplay at last slide
            clearInterval(intervalRef.current);
            setIsPlaying(false);
            return prev; // stay on last slide
          }
          return prev + 1;
        });
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isPlaying, slides.length]);

  // Scroll function
  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    const scrollAmount = 300;
    if (!container) return;
    if (direction === "left") container.scrollLeft -= scrollAmount;
    else container.scrollLeft += scrollAmount;
  };

  // Update arrow visibility
  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const isAtStart = container.scrollLeft <= 0;
    const isAtEnd =
      container.scrollLeft + container.clientWidth >= container.scrollWidth - 5;

    setAtStart(isAtStart);
    setAtEnd(isAtEnd);
  };

  // Check if container is scrollable
  const checkScrollable = () => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const isScrollableAvailable = container.scrollWidth > container.clientWidth;
    setIsScrollable(isScrollableAvailable);
    handleScroll();
  };

  // Attach listeners
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", checkScrollable);

    checkScrollable(); // initial check

    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkScrollable);
    };
  }, []);

  return (
    <div className="photo-xmot-type p-4">
      <section className="session-slides mt-3">
        <div>
          <SessionsCarousel
            selectedSession={selectedSession}
            setSelectedSession={setSelectedSession}
            sessionsData={sessions}
          />
        </div>

        <div className="displayLabels mt-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="videoDetailsPanel flex-fill">
              <div className="fs-12 fw-600 title">Participant ID</div>
              <strong id="info_ptid">12853</strong>
            </div>
            <div className="videoDetailsPanel flex-fill">
              <div className="fs-12 fw-600 title">Age</div>
              <strong id="info_age">55</strong>
            </div>
            <div className="videoDetailsPanel flex-fill">
              <div className="fs-12 fw-600 title">Gender</div>
              <strong id="info_gender">Male</strong>
            </div>
            <div className="videoDetailsPanel flex-fill">
              <div className="fs-12 fw-600 title">Location</div>
              <strong id="info_city">Cincinnati, United States</strong>
            </div>
          </div>
        </div>
      </section>

      <section className="my-3">
        <div className="row m-0">
          {/* LEFT SECTION - IMAGE + QUESTION */}
          <div className={showPlayerFullView ? "col-md-12" : "col-lg-7"}>
            <Card className="p-0 shadow-sm">
              <div className="position-relative">
                {/* MAIN IMAGE WRAPPER */}
                <div className="position-relative text-center mb-3">
                  {/* Main Image */}
                  <img
                    src={slides[activeIndex]}
                    className="img-fluid rounded shadow"
                    style={{
                      maxHeight: showPlayerFullView ? "85vh" : "500px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    alt=""
                  />

                  {/* Play/Pause Button */}
                  <button
                    className="play-btn bg-danger"
                    onClick={() => setIsPlaying(!isPlaying)}
                  >
                    {isPlaying ? (
                      <span className="pause-icon">❚❚</span>
                    ) : (
                      <span className="play-icon">▶</span>
                    )}
                  </button>
                </div>

                {/* THUMBNAILS */}
                <div className="d-flex align-items-center">
                  {isScrollable ? (
                    <div
                      className="photo-gallery-icon px-2"
                      style={{
                        opacity: atStart ? 0.5 : 1,
                        cursor: atStart ? "not-allowed" : "pointer",
                      }}
                    >
                      <i
                        className="pi pi-angle-left cursor-pointer"
                        onClick={() => scroll("left")}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    className="d-flex overflow-auto pb-3 g-2"
                    ref={scrollContainerRef}
                    style={{
                      scrollBehavior: "smooth",
                      gap: "0.5rem",
                      whiteSpace: "nowrap",
                      backgroundColor: "transparent",
                    }}
                  >
                    {thumbs.map((src, index) => (
                      <div
                        className="flex-shrink-0"
                        key={index}
                        style={{
                          height: "120px",
                          width: "170px",
                        }}
                      >
                        <img
                          src={src}
                          className={`img-fluid gallery-thumb h-100 w-100 ${
                            index === activeIndex ? "active-thumb" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setActiveIndex(index)}
                          alt=""
                        />
                      </div>
                    ))}
                  </div>

                  <Button
                    className="toggle-content-btn"
                    onClick={() => setShowPlayerFullView(!showPlayerFullView)}
                  >
                    <i className="pi pi-window-maximize"></i>
                  </Button>

                  {isScrollable ? (
                    <div
                      className="photo-gallery-icon px-2"
                      style={{
                        opacity: atEnd ? 0.5 : 1,
                        cursor: atEnd ? "not-allowed" : "pointer",
                      }}
                    >
                      <i
                        className="pi pi-angle-right cursor-pointer"
                        onClick={() => scroll("right")}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="mt-2">
                <AllTaskQuestionViewComponent
                  allTQToggle={allTQToggle}
                  handleAllTQToggle={(toggleValue) =>
                    setAllTQToggle(toggleValue)
                  }
                />
              </div>
            </Card>
          </div>

          {/* RIGHT SECTION - TRANSCRIPT & KEYWORDS */}
          <div className={showPlayerFullView ? "d-none" : "col-lg-5"}>
            {/* <Card className="shadow-sm"> */}
            <TabView className="transcript-tabs">
              <TabPanel header="Q&A">
                <div>
                  <div className="row my-2 px-2">
                    <div className="fw-bold col-6">TASKS/QUESTIONS</div>
                    <div className="fw-bold col-6">Answer</div>
                  </div>
                  <Divider />
                  <div className="row px-2">
                    <div className="px-2 col-6 mt-3">
                      <div className="my-2">
                        First, use the camera button to take a picture of your
                        kitchen.
                      </div>
                    </div>
                    <div className="px-2 col-6 mt-3">
                      <div className="my-2">N/A</div>
                    </div>

                    <div className="px-2 col-6 mt-3">
                      <div className="my-2">
                        Now take a picture of where you keep cleaning supplies.
                      </div>
                    </div>
                    <div className="px-2 col-6 mt-3">
                      <div className="my-2">N/A</div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Notes">
                <div className="my-2">
                  <label className="mb-1 fs-14">Enter Notes:</label>
                  <InputTextarea
                    autoResize
                    value={""}
                    onChange={(e) => console.log(e.target.value)}
                    rows={8}
                    className="w-100 inputField fs-14"
                  />
                  <small>Max 1000 characters.</small>

                  <div className="d-flex justify-content-center gap-2 mt-4 mb-5">
                    <Button
                      label="Cancel"
                      className="px-4 py-2 fw-bold cancel"
                      onClick={() => console.log("cancel")}
                    />
                    <Button
                      label={
                        <>
                          Save
                          {/* {isSubmitting && (
                            <ProgressSpinner
                              style={{
                                width: "20px",
                                height: "20px",
                                marginLeft: "8px",
                              }}
                              strokeWidth="4"
                              fill="transparent"
                              animationDuration=".5s"
                            />
                          )} */}
                        </>
                      }
                      className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
                      onClick={() => console.log("save")}
                    />
                  </div>
                </div>
              </TabPanel>
            </TabView>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PhotoOnlyXmotType;
